"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  poweredBy: "\n<div class=\"{{cssClasses.root}}\">\n  Search by\n  <a class=\"{{cssClasses.link}}\" href=\"{{url}}\" target=\"_blank\">Algolia</a>\n</div>"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/dist-es5-module/src/widgets/search-box/defaultTemplates.js
// module id = xBJ5
// module chunks = 0